<div class="modal-header">
  <div>
    <h4 class="modal-title">
      Usuario {{ user?.username }}
    </h4>
    <small>
      {{ user?.fullName }}
    </small>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div class="container-fluid">
    <div class="row">

      <div class="col-12 col-md-6 mb-3">
        <div class="row">

          <div class="col-12">
            <small>
              <b class="text-secondary">User</b>
            </small>
          </div>
          
          <div class="col-12">
            <div class="row">

              <div class="col">
                {{ user?.username }}
              </div>
              <div class="col-auto">
                <button 
                  (click)="utilService.copyToClipboard(user!.username)"
                  class="btn">
                  <i class="material-icons text-secondary">content_copy</i>
                </button>
              </div>

            </div>
          </div>

        </div>
      </div>
      
      <div class="col-12 col-md-6 mb-3">
        <div class="row">

          <div class="col-12">
            <small>
              <b class="text-secondary">Password</b>
            </small>
          </div>
          
          <div class="col-12">
            <div class="row">

              <div class="col">
                @if(showPassword) {

                  {{ user!.auxPassword }}

                } @else {
                  {{ utilService.censorText(user!.auxPassword ?? '') }}
                }
              </div>
              <div class="col-auto">

                <button 
                  (click)="showPassword = !showPassword"
                  class="btn">
                  <i class="material-icons text-secondary">
                    {{ showPassword ? 'visibility_off' : 'visibility' }}
                  </i>
                </button>

                <button 
                  (click)="utilService.copyToClipboard(user!.auxPassword ?? '')"
                  class="btn">
                  <i class="material-icons text-secondary">content_copy</i>
                </button>
              </div>

            </div>
          </div>

        </div>
      </div>

      @if(streetBuilding) {
        <div class="col-12 col-md-6 mb-3">
          <div class="row">

            <div class="col-12">
              <small>
                <b class="text-secondary">Calle</b>
              </small>
            </div>
            
            <div class="col-12">
              <div class="row">

                <div class="col">
                  {{ streetBuilding.name }}
                </div>
                <div class="col-auto">
                  <button 
                    (click)="utilService.copyToClipboard(streetBuilding.name!)"
                    class="btn">
                    <i class="material-icons text-secondary">content_copy</i>
                  </button>
                </div>

              </div>
            </div>

          </div>
        </div>
      }

      @if(houseFlat) {
        <div class="col-12 col-md-6 mb-3">
          <div class="row">

            <div class="col-12">
              <small>
                <b class="text-secondary">No.</b>
              </small>
            </div>
            
            <div class="col-12">
              <div class="row">

                <div class="col">
                  {{ houseFlat.number }}
                </div>
                <div class="col-auto">
                  <button 
                    (click)="utilService.copyToClipboard(houseFlat.number!)"
                    class="btn">
                    <i class="material-icons text-secondary">content_copy</i>
                  </button>
                </div>

              </div>
            </div>

          </div>
        </div>
      }

    </div>
  </div>
</div>
<div class="modal-footer">

  <div class="col-12 mt-3 mb-1">
    <button
      (click)="user?.downloadData(streetBuilding!, houseFlat!)"
      type="button"
      class="btn btn-outline-primary w-100">
      Descargar usuario
    </button>
  </div>

  <div class="col-12 mb-3">
    <button
      (click)="activeModal.close()"
      type="button"
      class="btn btn-success w-100">
      OK
    </button>
  </div>
</div>
